export default (client) => ({
  get(filterParams) {
    return client.request({
      method: 'get',
      url: '/providers/get',
      params: { ...filterParams },
    });
  },
});
